import axios, {
  type InternalAxiosRequestConfig,
} from 'axios';

import packageJson from '../../package.json';

const apiJSONInstance = axios.create();

const instance = axios.create();

let apiHome = '';

export const createStorebrandInterceptor = (getToken: () => Promise<string>) => (
  async (config: InternalAxiosRequestConfig) => {
    if (!apiHome) {
      apiHome = await apiJSONInstance
        .get('/api.json')
        .then(({ data }) => data.apihome as string);
    }

    config.headers.set('clientId', packageJson.name);

    if (config?.url?.startsWith('/api')) {
      return config;
    }

    /**
   * if the request is an open one, then
   * prepend apiHome, but don't attach
   * token of any kind
   */
    if (config?.url?.startsWith('/open')) {
    // eslint-disable-next-line no-param-reassign
      config.url = `${apiHome}${config.url}`;
      return config;
    }

    /**
   * if request specifies an absolute path (starts with http),
   * then don't attach anything to it. Otherwise attach the
   * Bearer token and prepend apiHome to it!
   */
    if (!config?.url?.startsWith('http')) {
      const token = await getToken();

      config.headers.set('Authorization', `Bearer ${token}`);
      // eslint-disable-next-line no-param-reassign
      config.url = `${apiHome}${config.url}`;

      return config;
    }

    return config;
  });

export default instance;
